import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import BarbersFilter from '../../../../common/BarbersFilter';
import RoleAware from '../../../../auth/roleAware';
import { USER_TYPES } from '../../../../auth/constants';
import DatePicker from '../../../../common/DatePickerV2';
import Queue from '../../../../queue/QueueContainer';

const Filters = ({
  startDate,
  endDate,
  children,
  disableBarberFilter,
  showUnassigned,
  endingDateMax,
  onDateChange,
  showCsvExport,
  isFetching,
  applyFilter,
  isSubmitDisabled,
  filters,
  csvJobName,
  csvModalTitle,
  useUserLocalTime,
  queueDateOnly,
}) => (
  <div className="c-report-filters">
    <div className="c-report-filters__item">
      <DatePicker
        end={endingDateMax}
        from={startDate}
        to={endDate}
        onChange={onDateChange}
        disabled={isFetching}
        range
        presets={useUserLocalTime ? 'userLocalDatePresets' : 'defaultPresets'}
      />
    </div>
    <RoleAware deny={USER_TYPES.barber} display-if={!disableBarberFilter}>
      <div className="c-report-filters__item">
        <BarbersFilter showUnassigned={showUnassigned} />
      </div>
    </RoleAware>
    { children }
    <div className="c-form-input-group">
      <button
        type="button"
        className={classnames('c-btn c-btn--medium u-border-radius-8', {
          'is-disabled': isSubmitDisabled,
        })}
        onClick={applyFilter}
        disabled={isSubmitDisabled}
        data-automation-id="button:applyFilter"
      >
        Submit
      </button>
    </div>
    <div className="small--ml- small-mt-" display-if={showCsvExport}>
      <Queue
        name="reports"
        btnLabel="Export to CSV"
        btnClass="c-btn c-btn--medium"
        jobName={csvJobName}
        label={csvModalTitle}
        filters={filters}
        dateOnly={queueDateOnly}
      />
    </div>
  </div>
);

Filters.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  disableBarberFilter: PropTypes.bool,
  showUnassigned: PropTypes.bool,
  endingDateMax: PropTypes.string.isRequired,
  showCsvExport: PropTypes.bool,
  isFetching: PropTypes.bool.isRequired,
  applyFilter: PropTypes.func.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  csvJobName: PropTypes.string,
  csvModalTitle: PropTypes.string,
  useUserLocalTime: PropTypes.bool,
  queueDateOnly: PropTypes.bool,
};

Filters.defaultProps = {
  disableBarberFilter: false,
  children: null,
  showUnassigned: false,
  showCsvExport: true,
  csvJobName: '',
  csvModalTitle: '',
  useUserLocalTime: false,
  queueDateOnly: false,
};

export default Filters;
